import React from "react";

import "./Grid.css";

export const GridRow: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="grid-row">{children}</div>;

interface GridColumnProps {
	columnSize: number;
}

export const GridColumn: React.FunctionComponent<
	React.PropsWithChildren<GridColumnProps>
> = ({ columnSize, children }) => (
	<div className={`grid-column grid-column--${columnSize}`}>{children}</div>
);

export const SplitRow: React.FunctionComponent<React.PropsWithChildren> = ({
	children
}) => <div className="split-row">{children}</div>;

interface SplitColumnProps {
	side: "left" | "right";
}

export const SplitColumn: React.FunctionComponent<
	React.PropsWithChildren<SplitColumnProps>
> = ({ side, children }) => (
	<div className={`split-column split-column--${side}`}>{children}</div>
);
